/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ErpProvisioningStatusRequest { 
    /**
     * Unique transaction ID to query the provisioning status
     */
    saasTransactionID: string;
}

